export default {
  name: 'CoreDtwinStateTableSourceIcon',
  props: {
    item: {
      type: Object,
      required: true
    },
    showName: {
      type: Boolean,
      required: false,
      default: false
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    icon() {
      return this.metaObj.icon;
    },
    image() {
      return this.metaObj.image;
    },
    name() {
      return this.metaObj.name || this.metaObj.title;
    },
    metaObj() {
      if (this.item.properties.binding.type === 'bridge') {
        let config = this.bridgeConfigs.find(c => parseInt(c.configId) === parseInt(this.item.properties.binding.options.configId));
        if (config) {
          return config;
        }
      }
      return this.dataSources.find(d => d.type === this.item.properties.binding.type) || {};
    }
  }
};